const initializeConversationTyping = () => {
    const composer = document.querySelector(
        '[data-message-composer]'
    );

    const indicator = document.querySelector(
        '[data-typing-indicator]'
    );

    if (!composer || !indicator) {
        return;
    }

    const textarea = composer.querySelector(
        'textarea[name="body"]'
    );

    const typingText = indicator.querySelector(
        '[data-typing-text]'
    );

    const updateUrl =
        composer.dataset.typingUpdateUrl;

    const statusUrl =
        composer.dataset.typingStatusUrl;

    if (
        !textarea
        || !typingText
        || !updateUrl
        || !statusUrl
    ) {
        return;
    }

    let lastTypingUpdateAt = 0;
    let typingTimeout = null;
    let statusInterval = null;
    let statusRequestInProgress = false;

    const sendTypingUpdate = async () => {
        const now = Date.now();

        if (
            now - lastTypingUpdateAt < 3000
        ) {
            return;
        }

        lastTypingUpdateAt = now;

        try {
            await fetch(
                updateUrl,
                {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        Accept: 'application/json',
                        'X-Requested-With':
                            'XMLHttpRequest',
                        'X-CSRF-TOKEN':
                            document
                                .querySelector(
                                    'meta[name="csrf-token"]'
                                )
                                ?.getAttribute('content')
                                ?? '',
                    },
                }
            );
        } catch {
            // Typing indicators are non-critical.
        }
    };

    const hideIndicator = () => {
        indicator.classList.add('hidden');
        typingText.textContent = '';
    };

    const checkTypingStatus = async () => {
        if (statusRequestInProgress) {
            return;
        }

        statusRequestInProgress = true;

        try {
            const response = await fetch(
                statusUrl,
                {
                    method: 'GET',
                    credentials: 'same-origin',
                    headers: {
                        Accept: 'application/json',
                        'X-Requested-With':
                            'XMLHttpRequest',
                    },
                }
            );

            if (!response.ok) {
                hideIndicator();
                return;
            }

            const data = await response.json();

            if (
                data.typing
                && data.member_name
            ) {
                const usesPluralVerb =
                    data.member_name.includes(' and ')
                    || data.member_name === 'Several members';

                typingText.textContent =
                    `${data.member_name} ${usesPluralVerb
                        ? 'are'
                        : 'is'} typing…`;

                indicator.classList.remove(
                    'hidden'
                );
            } else {
                hideIndicator();
            }
        } catch {
            hideIndicator();
        } finally {
            statusRequestInProgress = false;
        }
    };

    const handleTyping = () => {
        if (
            textarea.value.trim() === ''
        ) {
            return;
        }

        sendTypingUpdate();

        window.clearTimeout(
            typingTimeout
        );

        typingTimeout = window.setTimeout(
            () => {
                lastTypingUpdateAt = 0;
            },
            5000
        );
    };

    textarea.addEventListener(
        'input',
        handleTyping
    );

    checkTypingStatus();

    statusInterval = window.setInterval(
        checkTypingStatus,
        2000
    );

    window.addEventListener(
        'beforeunload',
        () => {
            window.clearTimeout(
                typingTimeout
            );

            window.clearInterval(
                statusInterval
            );
        }
    );
};

if (
    document.readyState === 'loading'
) {
    document.addEventListener(
        'DOMContentLoaded',
        initializeConversationTyping
    );
} else {
    initializeConversationTyping();
}